import { isSafari } from 'shared/utils/browserDetector';

interface IVideo {
  className?: string;
  'data-qa'?: string;
  movUrl?: string;
  onClick?: () => void;
  poster?: string;
  webmUrl?: string;
  playsInline?: boolean;
}

export const Video = ({
  'data-qa': dataQa = null,
  movUrl,
  webmUrl,
  className,
  poster,
  onClick,
  playsInline = true,
}: IVideo) => {
  const isSafariBrowser = isSafari(); // Safari cannot play webm with transparent backgrounds

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <video
      autoPlay
      className={className}
      loop
      muted
      onClick={handleOnClick}
      playsInline={playsInline}
      poster={poster}
      preload="none"
      data-qa={dataQa}
    >
      {webmUrl && !isSafariBrowser && <source src={webmUrl} type="video/webm" />}
      {movUrl && <source src={movUrl} type="video/mp4" />}
    </video>
  );
};
